import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import { IDLING_CONSUMPTION_OBSERVATION_COLUMNS } from '../../../../config/columns';
import {
  clearIdlingConsumptionObservations,
  getIdlingConsumptionObservations,
} from '../../../../actions';
import Table from '../../../common/Table';
import { IDLING_CONSUMPTION_PATH } from '../../../../config/paths';
import Content from '../../../layout/Content';

export const IdlingConsumptionObservations = ({
  breadcrumbs,
  idlingConsumptionObservations,
  loading,
  dispatchGetidlingConsumptionObservations,
  dispatchClearIdlingConsumptionObservations,
}) => {
  useLayoutEffect(() => () => dispatchClearIdlingConsumptionObservations(), []);

  const data = idlingConsumptionObservations.get('content') || [];
  const pages = idlingConsumptionObservations.get('totalPages') || null;
  const defaultPageSize =
    idlingConsumptionObservations.get('size') || DEFAULT_PAGE_SIZE;
  const content = (
    <Table
      columns={IDLING_CONSUMPTION_OBSERVATION_COLUMNS}
      data={data}
      pages={pages}
      defaultPageSize={defaultPageSize}
      fetchData={dispatchGetidlingConsumptionObservations}
      modelPath={IDLING_CONSUMPTION_PATH}
      loading={loading}
      filterable
      navigateToModelOnRowClick
    />
  );

  return (
    <Content
      title="Control de Consumos por Ralentí"
      breadcrumbs={breadcrumbs}
      content={content}
    />
  );
};

const mapDispatchToProps = {
  dispatchGetidlingConsumptionObservations: getIdlingConsumptionObservations,
  dispatchClearIdlingConsumptionObservations:
    clearIdlingConsumptionObservations,
};

const mapStateToProps = ({ TrafficUnit }) => ({
  breadcrumbs: [
    ...TrafficUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Control de Consumos por Ralentí',
      href: IDLING_CONSUMPTION_PATH,
    },
  ],
  idlingConsumptionObservations: TrafficUnit.IdlingConsumption.getIn([
    'all',
    'content',
  ]),
  loading: TrafficUnit.IdlingConsumption.getIn(['all', 'loading']),
});

IdlingConsumptionObservations.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  idlingConsumptionObservations: PropTypes.instanceOf(Immutable.Map),
  loading: PropTypes.bool,
  dispatchGetidlingConsumptionObservations: PropTypes.func.isRequired,
  dispatchClearIdlingConsumptionObservations: PropTypes.func.isRequired,
};

IdlingConsumptionObservations.defaultProps = {
  idlingConsumptionObservations: null,
  loading: false,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(IdlingConsumptionObservations);
